module.exports = __webpack_public_path__ + "static/media/icon_consumidor_final.9ef5fbc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_consumidor_final.svg
// module id = 619
// module chunks = 0